import loadable from "@loadable/component";
import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { AccessoriesATCProps } from "./AccessoriesGrid/AccessoriesATC";
import { productAdjacementInformation } from "../pluginOwners";

export const AccessoriesComponent: ComponentToBeRegistered<AccessoriesATCProps> = {
  placeholder: Placeholder.AfterTab,
  Component: loadable(() => import("./AccessoriesGrid/AccessoriesATC")),
  name: "ChecksAccessories",
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const mpvId = context.pageProps.mpv.mpvId;
    const isAccessoriesEnabled =
      mpvId === "walletTrialChecks" ||
      mpvId === "walletChecks" ||
      mpvId === "large3PerPageChecks" ||
      mpvId === "laserChecks";
    return isAccessoriesEnabled;
  },
};

export const checksAccessories: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, AccessoriesComponent);
  },
  pluginOwner: productAdjacementInformation,
};
